/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInnerSchedulesInner } from './GetProducts200ResponseItemsInnerSchedulesInner';
import {
    GetProducts200ResponseItemsInnerSchedulesInnerFromJSON,
    GetProducts200ResponseItemsInnerSchedulesInnerFromJSONTyped,
    GetProducts200ResponseItemsInnerSchedulesInnerToJSON,
    GetProducts200ResponseItemsInnerSchedulesInnerToJSONTyped,
} from './GetProducts200ResponseItemsInnerSchedulesInner';
import type { GetProducts200ResponseItemsInnerInformation } from './GetProducts200ResponseItemsInnerInformation';
import {
    GetProducts200ResponseItemsInnerInformationFromJSON,
    GetProducts200ResponseItemsInnerInformationFromJSONTyped,
    GetProducts200ResponseItemsInnerInformationToJSON,
    GetProducts200ResponseItemsInnerInformationToJSONTyped,
} from './GetProducts200ResponseItemsInnerInformation';
import type { GetProducts200ResponseItemsInnerAllergensInner } from './GetProducts200ResponseItemsInnerAllergensInner';
import {
    GetProducts200ResponseItemsInnerAllergensInnerFromJSON,
    GetProducts200ResponseItemsInnerAllergensInnerFromJSONTyped,
    GetProducts200ResponseItemsInnerAllergensInnerToJSON,
    GetProducts200ResponseItemsInnerAllergensInnerToJSONTyped,
} from './GetProducts200ResponseItemsInnerAllergensInner';

/**
 * 
 * @export
 * @interface PatchProductRequest
 */
export interface PatchProductRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchProductRequest
     */
    price?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductRequest
     */
    modifierGroups?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductRequest
     */
    hasSchedule?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductRequest
     */
    controlEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    imageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    kitchenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    course?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductRequest
     */
    taxCategories?: string | null;
    /**
     * 
     * @type {Array<GetProducts200ResponseItemsInnerAllergensInner>}
     * @memberof PatchProductRequest
     */
    allergens?: Array<GetProducts200ResponseItemsInnerAllergensInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductRequest
     */
    specifications?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductRequest
     */
    additives?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductRequest
     */
    isPrepackaged?: boolean | null;
    /**
     * 
     * @type {GetProducts200ResponseItemsInnerInformation}
     * @memberof PatchProductRequest
     */
    information?: GetProducts200ResponseItemsInnerInformation | null;
    /**
     * 
     * @type {Array<GetProducts200ResponseItemsInnerSchedulesInner>}
     * @memberof PatchProductRequest
     */
    schedules?: Array<GetProducts200ResponseItemsInnerSchedulesInner>;
}

/**
 * Check if a given object implements the PatchProductRequest interface.
 */
export function instanceOfPatchProductRequest(value: object): value is PatchProductRequest {
    return true;
}

export function PatchProductRequestFromJSON(json: any): PatchProductRequest {
    return PatchProductRequestFromJSONTyped(json, false);
}

export function PatchProductRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchProductRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'price': json['price'] == null ? undefined : json['price'],
        'modifierGroups': json['modifierGroups'] == null ? undefined : json['modifierGroups'],
        'hasSchedule': json['hasSchedule'] == null ? undefined : json['hasSchedule'],
        'controlEnabled': json['controlEnabled'] == null ? undefined : json['controlEnabled'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'color': json['color'] == null ? undefined : json['color'],
        'course': json['course'] == null ? undefined : json['course'],
        'taxCategories': json['taxCategories'] == null ? undefined : json['taxCategories'],
        'allergens': json['allergens'] == null ? undefined : ((json['allergens'] as Array<any>).map(GetProducts200ResponseItemsInnerAllergensInnerFromJSON)),
        'specifications': json['specifications'] == null ? undefined : json['specifications'],
        'additives': json['additives'] == null ? undefined : json['additives'],
        'isPrepackaged': json['isPrepackaged'] == null ? undefined : json['isPrepackaged'],
        'information': json['information'] == null ? undefined : GetProducts200ResponseItemsInnerInformationFromJSON(json['information']),
        'schedules': json['schedules'] == null ? undefined : ((json['schedules'] as Array<any>).map(GetProducts200ResponseItemsInnerSchedulesInnerFromJSON)),
    };
}

export function PatchProductRequestToJSON(json: any): PatchProductRequest {
    return PatchProductRequestToJSONTyped(json, false);
}

export function PatchProductRequestToJSONTyped(value?: PatchProductRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'price': value['price'],
        'modifierGroups': value['modifierGroups'],
        'hasSchedule': value['hasSchedule'],
        'controlEnabled': value['controlEnabled'],
        'description': value['description'],
        'imageId': value['imageId'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'color': value['color'],
        'course': value['course'],
        'taxCategories': value['taxCategories'],
        'allergens': value['allergens'] == null ? undefined : ((value['allergens'] as Array<any>).map(GetProducts200ResponseItemsInnerAllergensInnerToJSON)),
        'specifications': value['specifications'],
        'additives': value['additives'],
        'isPrepackaged': value['isPrepackaged'],
        'information': GetProducts200ResponseItemsInnerInformationToJSON(value['information']),
        'schedules': value['schedules'] == null ? undefined : ((value['schedules'] as Array<any>).map(GetProducts200ResponseItemsInnerSchedulesInnerToJSON)),
    };
}

